import mitt from 'mitt';
import WebsocketService from "./ws-service.js"
const EVENT_NOTIFY = 'EVENT_PUBLISH_SUCCESS_NOTIFICATION';
const TYPE_SUCCESS = 'TYPE_SUCCESS';
const TYPE_DANGER = 'TYPE_DANGER';
const TYPE_WARNING = 'TYPE_WARNING';
const notification_emitter = mitt();

function start() {
    WebsocketService.ws_emitter.on(WebsocketService.EVENT_SESSION_CONNECTED, device => notification_emitter.emit(EVENT_NOTIFY, { type: TYPE_SUCCESS, title: 'Device Connected', content: device.name }));
    WebsocketService.ws_emitter.on(WebsocketService.EVENT_SESSION_DISCONNECTED, session_uuid => notification_emitter.emit(EVENT_NOTIFY, { type: TYPE_DANGER, title: 'Device Disconnected', content: session_uuid }));
}
function notify(type, title, content) {
    if (type == null)
        type = TYPE_SUCCESS;
    notification_emitter.emit(EVENT_NOTIFY, { type: type, title: title, content: content });
}

export default {
    EVENT_NOTIFY,
    TYPE_SUCCESS,
    TYPE_DANGER,
    TYPE_WARNING,
    notification_emitter,
    start,
    notify,
}